import React from "react";

const Loader = () => {
  return (
    <div className="loader">
      <p>Cargando...</p>
    </div>
  );
};

export default Loader;